<template>
    <div class="view view-analytics">
        <HeaderAnalytics />
        <LinkAnalyticsPerfection />
        <LinkAnalyticsPractice />
        <LinkAnalyticsCorrectness />

        <BtnChallenge />
        <BtnPracticeModes />
        <Navbar />
    </div>
</template>
<script>
    import HeaderAnalytics from '@/components/HeaderAnalytics.vue';
    import LinkAnalyticsPerfection from '@/components/LinkAnalyticsPerfection.vue';
    import LinkAnalyticsPractice from '@/components/LinkAnalyticsPractice.vue';
    import LinkAnalyticsCorrectness from '@/components/LinkAnalyticsCorrectness.vue';
    import BtnChallenge from '@/components/BtnChallenge.vue';
    import BtnPracticeModes from '@/components/BtnPracticeModes.vue';
    import Navbar from '@/components/Navbar.vue';

    export default {
        components: {
            HeaderAnalytics,
            LinkAnalyticsPerfection,
            LinkAnalyticsPractice,
            LinkAnalyticsCorrectness,
            BtnChallenge,
            BtnPracticeModes,
            Navbar,
        }
    };
</script>
<style scoped src="@/css/views/view-analytics.css"></style>